import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { LayoutPrintFormService } from "../layout-print-form/layout-print-form.service";
import { Router } from "@angular/router";
import { ActivatedRoute, ParamMap } from "@angular/router";
import {QrCodeService} from "../qr-code/qr-code.service";

@Component({
  selector: 'app-print-qrcode',
  templateUrl: './print-qrcode.component.html',
  styleUrls: ['./print-qrcode.component.css'],
  providers: [
    LayoutPrintFormService,
    QrCodeService
  ]
})
export class PrintQrcodeComponent implements OnInit {

  printData: any;
  isLoading:boolean;
  layout: any;
  configCss: any;
  layoutPrint: any;
  style: any;
  idLayout: any;
  css:string = '';
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private layoutPrintFormService: LayoutPrintFormService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router,
    private qrCodeService: QrCodeService
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.configCss = {
      '.layout-print': {
        'width': { value: [10.3], unit: 'cm' }
      },
      '.item-sm': {
        'width': { value: [5], unit: 'cm' },
        'height': { value: [4], unit: 'cm' },
        'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
      },
      '.item-lg': {
        'width': { value: [5], unit: 'cm' },
        'height': { value: [5], unit: 'cm' },
        'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
      },
      '.info-sm': {
        'font-size': { value: [10], unit: 'pt' },
        'line-height': { value: [0.85], unit: '' },
      },
      '.info-lg': {
        'font-size': { value: [12], unit: 'pt' },
        'line-height': { value: [1], unit: '' },
      },
      '.sub-info-lg': {
        'font-size': { value: [12], unit: 'pt' },
        'height': { value: [0.5], unit: 'cm' },
        'line-height': { value: [0.9], unit: '' }
      },
      'qrcode-sm': { value: [1.6], unit: 'cm' },
      'qrcode-lg': { value: [1.9], unit: 'cm' }
    }
   }

  ngOnInit() {
    this.printData = new Array();
    this.initData();
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idLayout = params.get('id');
      this.getLayoutPrintById();
      // this.renderCss();
    });
  }

  getLayoutPrintById() {
    this.isLoading = true;
    this.layoutPrintFormService.getLayoutPrint(this.idLayout)
      .then(res => {
        if (res.status === 1) {
          this.layoutPrint = res.data;
          this.configCss = JSON.parse(this.layoutPrint.jsonCss);
          this.renderCss();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      }).catch(err => console.log(err))
  }

  renderCss() {
    // this.configCss['.item-sm']['height'].value[0] = this.configCss['.item-sm']['padding'].value[0] + this.configCss['.item-sm']['padding'].value[2] + this.configCss['qrcode-sm'].value[0];
    // this.configCss['.item-lg']['height'].value[0] = this.configCss['.item-lg']['padding'].value[0] + this.configCss['.item-lg']['padding'].value[2] + this.configCss['.sub-info-lg']['height'].value[0] + this.configCss['qrcode-lg'].value[0];
    // this.configCss['.layout-print']['width'].value[0] = 2 * this.configCss['.item-sm']['width'].value[0] + 0.3;
    this.css = '';
    for (let key1 in this.configCss) {
      if (key1 === 'qrcode-sm' || key1 === 'qrcode-lg') {
        continue;
      }
      let temp: string = '';
      for (let key2 in this.configCss[key1]) {
        if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 1) {
          temp += `
          ${key2}: ${this.configCss[key1][key2].value}${this.configCss[key1][key2].unit};`
        }
        if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 4) {
          temp += `${key2}: ${this.configCss[key1][key2].value[0]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[1]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[2]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[3]}${this.configCss[key1][key2].unit};`;
        }
      }
      this.css += `
      ${key1} {${temp}
      }`;

    }
    this.style = this.sanitizer.bypassSecurityTrustHtml('<style>' + this.css + '</style>');
  }

  initData(){
    this.isLoading = true;
    let data = JSON.parse(localStorage.getItem('printData'));
    if (data !== null ) {
      let printedID = [];
      for (let item of data) {
        printedID.push(item.serialId);
      }

      this.qrCodeService.setUsedQrCode(printedID, true).then(res => {
        console.log(res)
      }).catch(err => console.log(err));
      this.printData = data;
    } else {
      this.isLoading = false;
    }
  }

  //print theo so luong qrcode
  parseData(data){
    for (let i = 0; i < data.length; i++) {
      let count = 0;
      while (count < data[i].numberPerCode) {
        this.printData.push(data[i]);
        count++;
      }
      this.printData.push(data[i]);
    }
    this.isLoading = false;
  }

  print(){
    localStorage.setItem("layout", JSON.stringify(this.layout));
    window.print();
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/print-qrcode/print-qrcode.component.ts